import clsx from "clsx";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { NONE } from "../../../consts/strings";
import {
  CHOICE_DRIVER_TYPE,
  DR_DRIVER_TYPE,
} from "../../../consts/driverTypes";
import { palette } from "../../../theme/palette";

import { View } from "../../Base";
import { DriverProfileModalContent } from "../DriverProfileModal/DriverProfileModalContent";
import { AppProfileModalContent } from "../DriverProfileModal/AppProfileModalContent";

const useStyles = makeStyles({
  container: {
    padding: "0px",
    display: "flex",
    flexDirection: "column",
  },
  topRowContainer: {
    margin: "1rem 1rem 0.5rem 1rem",
    display: "flex",
    gap: "1rem",
  },
  userSelect: {
    width: "18rem",
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1rem -1.5rem 0rem -1.5rem",
    padding: "0rem 1.7rem 0rem 1.7rem",
    backgroundColor: palette.dpdLightGrey,
    height: "3rem",
  },
  sectionContent: {
    display: "flex",
    marginTop: "0.5rem",
  },
  driverCodeInput: {
    width: "14rem",
  },
  disabled: {
    pointerEvents: "none",
    "& input": {
      color: palette.typography.black.disabled,
    },
  },
});

export const AddDriverContent = ({
  users,
  selectedUser,
  onUserChange,
  driverCode,
  onDriverCodeChange,
  driverTypes,
  driverProfileEdit,
  onDriverProfileEditChange,
  errors,
}) => {
  const styles = useStyles();
  const disabled = !selectedUser || selectedUser.userId === NONE;
  const disableDetailsEdit = disabled || driverTypes.length <= 1;

  return (
    <View className={styles.container}>
      <View className={styles.topRowContainer}>
        <FormControl className={styles.userSelect} variant={"outlined"}>
          <InputLabel id="new-driver-user">User</InputLabel>
          <Select
            label={"User"}
            labelId="new-driver-user"
            name={"user"}
            onChange={onUserChange}
            value={selectedUser.userId || NONE}
          >
            {users.map(({ userId, userName }, index) => (
              <MenuItem key={index} value={userId}>
                {userId !== NONE ? `${userName} (${userId})` : NONE}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          className={clsx(
            styles.driverCodeInput,
            disableDetailsEdit && styles.disabled
          )}
          value={driverCode}
          onChange={onDriverCodeChange}
          variant={"outlined"}
          label={"Driver Code"}
          name={"driverCode"}
          error={!!errors["driverCode"]}
          FormHelperTextProps={{
            style: { marginLeft: "0px" },
          }}
          InputLabelProps={
            disableDetailsEdit && {
              style: {
                color: palette.typography.black.disabled,
              },
            }
          }
          helperText={errors["driverCode"]}
          disabled={disableDetailsEdit}
        />
      </View>

      <View className={styles.sectionHeader}>
        <Typography className={styles.title}>{"DRIVER PROFILE"}</Typography>
      </View>
      <View className={styles.sectionContent}>
        <DriverProfileModalContent
          disabled={disabled}
          allowVehicleTypeChange={
            driverProfileEdit.driverType !== DR_DRIVER_TYPE
          }
          showAlternativeLocation={
            driverProfileEdit.driverType === CHOICE_DRIVER_TYPE
          }
          driverTypes={driverTypes}
          driverProfileEdit={driverProfileEdit}
          onChange={onDriverProfileEditChange}
          errors={errors}
        />
      </View>
      <View className={styles.sectionHeader}>
        <Typography className={styles.title}>{"APP PROFILE"}</Typography>
      </View>
      <View className={styles.sectionContent}>
        <AppProfileModalContent
          disabled={disabled}
          driverProfileEdit={driverProfileEdit}
          onChange={onDriverProfileEditChange}
          errors={errors}
        />
      </View>
    </View>
  );
};
